<template>
  <div class="flex items-center gap-2">
    <slot/>
    <niceone-image v-if="hasSixtyImages" :src="$publicPath('/images/360degree.svg')" class="w-[26px] cursor-pointer"
                   @click="openThreeSixtyPopup"/>
    <niceone-image v-if="hasBeforeAfterImages" :src="$publicPath('/images/imageComparison.svg')"
                   class="w-[26px] cursor-pointer" @click="openComparePopup"/>
    <play-video :data="data" class="cursor-pointer flex"/>
    <favourite-icon :id="id" :product="data" class="cursor-pointer"/>
  </div>
</template>

<script setup>
import FavouriteIcon from "@/components/product/FavouriteIcon";
import PlayVideo from "@/components/product/PlayVideo";
import {EVENTS} from "@/constants/events";

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  data: {
    type: Object,
    default: {},
  }
});

const hasSixtyImages = computed(() => !!props?.data?.images360?.length || false)
const hasBeforeAfterImages = computed(() => !!props?.data?.images_after_before?.length || false)

const {emit: openComparePopup} = useEventBus(EVENTS.COMPARE_POPUP);
const {emit: openThreeSixtyPopup} = useEventBus(EVENTS.THREE_SIXTY_POPUP);
</script>

<style lang="scss" scoped></style>
